<template lang="pug">
section.src-components-ventas-toolbar
  v-btn(@click="toolbar_click('update')" color="secondary" dark small) #[v-icon mdi-update] Actualizar
  v-btn.ma-2.mx-2(fab dark small color="teal" :disabled="loading" @click="toolbar_click('excel')") #[v-icon(dark) mdi-microsoft-excel]
  //v-btn(icon @click="print()") #[v-icon mdi-printer]  
</template>

<script lang="js">
  import { EventBus } from '@/event-bus';
  export default  {
    name: 'src-components-ventas-toolbar',
    props: [],
    mounted () {

    },
    data () {
      return {

      }
    },
    methods: {
      toolbar_click(name) {
        EventBus.$emit('toolbar_click',name);
      },
    },
    computed: {

    }
}


</script>

<style scoped lang="scss">
  .src-components-ventas-toolbar {

  }
</style>
